import React from 'react';
import Title from '../../../../../@casino/ui/title';

const ReportTraffic = () => {

  return (
    <div>
      <Title label="Отчет по трафику" />
    </div>
  )
}

export default ReportTraffic;